import React, { useState } from "react";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  FormControlLabel,
  Checkbox,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
  FormHelperText,
} from "@mui/material";

import { useTranslation } from "react-i18next";

const RoleFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  ...props
}) => {
  const classes = useStyles();
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "role-entry";
  const MenuUrl = JSON.parse(localStorage.getItem("MenuUrl"));
  const ProductGroup_List = JSON.parse(
    localStorage.getItem("ProductGroupList")
  );
  const { t, i18n } = useTranslation();

  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);

  React.useEffect(() => {
    console.log("ItemGroupIds=== ", formData);

    if (formData.ItemGroupIds && typeof formData.ItemGroupIds === "string") {
      const roleIds = formData.ItemGroupIds.split(",").map((id) => id.trim());
      formData["multiselectItemGroup"] = roleIds;
      setSelectedRoles(roleIds);
    }
  }, [formData]);

  const handleRoleCheckboxChange = (ItemGroupId) => {
    const updatedRoles = [...selectedRoles];
    if (updatedRoles.includes(ItemGroupId)) {
      // If ItemGroupId is already selected, remove it
      updatedRoles.splice(updatedRoles.indexOf(ItemGroupId), 1);
    } else {
      // If ItemGroupId is not selected, add it
      updatedRoles.push(ItemGroupId);
    }
    formData["multiselectItemGroup"] = updatedRoles;
    setSelectedRoles(updatedRoles);
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading text-center">
              <div className="sw_heading_title_inner">
                {" "}
                {
                  DispensingLanguage[lan][menukey]["Role Entry Form - Add/Edit"]
                }{" "}
              </div>
            </div>
          </Grid>
        </div>

        {/* New row */}
        <Grid container spacing={10}>
          {/* New row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardHeader
                title={DispensingLanguage[lan][menukey]["Role Entry from"]}
              />
              <CardContent>
                <Grid container spacing={10}>
                  <Grid item xs={4} sm={12}>
                    <Grid container spacing={4}>
                      <Grid item xs={6} sm={4}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          error={!!errorObject.role}
                          helperText={errorObject.role}
                          required
                          id="role"
                          name="role"
                          label={DispensingLanguage[lan][menukey]["Role Name"]}
                          value={formData.role}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <FormControl variant="standard" className={classes.fullWidth}>
                          <InputLabel id="demo-simple-select-helper-label">
                            {
                              DispensingLanguage[lan][menukey][
                                "Default Redirect"
                              ]
                            }
                          </InputLabel>
                          <Select
                            disabled={!!props.permissionType}
                            error={!!errorObject.defaultredirect}
                            labelId="demo-simple-select-helper-label"
                            id="defaultredirect"
                            name="defaultredirect"
                            value={formData.defaultredirect}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                          label={DispensingLanguage[lan][menukey][ "Default Redirect" ]}>
                            {MenuUrl.map((item, index) => {
                              return (
                                <MenuItem key={item.url} value={item.url}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText error={!!errorObject.defaultredirect}>
                            {errorObject.defaultredirect}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      {/* <Grid item xs={6} sm={3}>
                        <FormControl variant="standard" className={classes.fullWidth}>
                          <InputLabel id="demo-simple-select-helper-label">
                            {DispensingLanguage[lan][menukey]["Product Group"]}*
                          </InputLabel>
                          <Select
                            disabled={!!props.permissionType}
                            error={!!errorObject.ItemGroupId}
                            required
                            labelId="demo-simple-select-helper-label"
                            id="ItemGroupId"
                            name="ItemGroupId"
                            value={formData.ItemGroupId}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                          label={`${DispensingLanguage[lan][menukey]["Product Group"]} *`}>
                            {ProductGroup_List.map((item, index) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText error={!!errorObject.ItemGroupId}>
                            {errorObject.ItemGroupId}
                          </FormHelperText>
                        </FormControl>
                      </Grid> */}

                      
                      <Grid item xs={6} sm={3} className="">
                        <InputLabel id="demo-simple-select-helper-label">
                          {DispensingLanguage[lan][menukey]["Product Group"]}*
                        </InputLabel>
                        {ProductGroup_List.map((group) => (
                          <FormControlLabel
                            key={group.id}
                            control={
                              <Checkbox
                                className="checkBoxCustomdynamic"
                                disabled={!!props.permissionType}
                                color="primary"
                                checked={selectedRoles.includes(
                                  String(group.id)
                                )}
                                onChange={() =>
                                  handleRoleCheckboxChange(String(group.id))
                                }
                                id={`id_${group.id}`}
                                name="multiselectItemGroup[]"
                                value={String(group.id)}
                              />
                            }
                            label={group.name}
                          />
                        ))}
                      </Grid>
                      
                    </Grid>


                    <Grid container spacing={4}>

                        <Grid item xs={6} sm={3} className="sw_active_patient">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  className="checkBoxCustomdynamic"
                                  disabled={!!props.permissionType}
                                  color="primary"
                                  checked={formData.bFacilitySelected}
                                  onChange={(e) => handleCheck(e)}
                                  name="bFacilitySelected"
                                  value="no"
                                />
                              }
                              label={DispensingLanguage[lan][menukey]["Is Active"]}
                            />
                          </Grid>
                          

                          <Grid item xs={6} sm={3} className="sw_active_patient">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  className="checkBoxCustomdynamic"
                                  disabled={!!props.permissionType}
                                  color="primary"
                                  checked={formData.IsAllFacility}
                                  onChange={(e) => handleCheck(e)}
                                  name="IsAllFacility"
                                  value="no"
                                />
                              }
                              label={DispensingLanguage[lan][menukey]["Allow all Facility Data Entry"]}
                            />
                          </Grid>

                          <Grid item xs={6} sm={3} className="sw_active_patient">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  className="checkBoxCustomdynamic"
                                  disabled={!!props.permissionType}
                                  color="primary"
                                  checked={formData.IsAllowOrderComplete}
                                  onChange={(e) => handleCheck(e)}
                                  name="IsAllowOrderComplete"
                                  value="no"
                                />
                              }
                              label={DispensingLanguage[lan][menukey]["Is Allow Order Complete"]}
                            />
                          </Grid>

                    </Grid>

                    {/* <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} className="">
                        <InputLabel id="demo-simple-select-helper-label">
                          {DispensingLanguage[lan][menukey]["Product Group"]}*
                        </InputLabel>
                        {ProductGroup_List.map((group) => (
                          <FormControlLabel
                            key={group.id}
                            control={
                              <Checkbox
                                className="checkBoxCustomdynamic"
                                disabled={!!props.permissionType}
                                color="primary"
                                checked={selectedRoles.includes(
                                  String(group.id)
                                )}
                                onChange={() =>
                                  handleRoleCheckboxChange(String(group.id))
                                }
                                id={`id_${group.id}`}
                                name="multiselectItemGroup[]"
                                value={String(group.id)}
                              />
                            }
                            label={group.name}
                          />
                        ))}
                      </Grid>
                    </Grid> */}


                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Action buttons */}
          {addProductForm ? (
            <Grid item xs={12} className="mt-4 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => handleReset()}
              >
                {t(DispensingLanguage[lan][menukey]["Reset"])}
              </Button>
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                {t(DispensingLanguage[lan][menukey]["Save"])}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/role-entry")}
              >
                {t(DispensingLanguage[lan][menukey]["Cancel"])}
              </Button>
            </Grid>
          ) : (
            <Grid item xs={12} className="mt-2 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleUpdate()}
              >
                {t(DispensingLanguage[lan][menukey]["update"])}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/role-entry")}
              >
                {t(DispensingLanguage[lan][menukey]["Cancel"])}
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default RoleFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
